module.exports = __webpack_public_path__ + "img/info-icon.73b5f632.svg";